import { render } from "./AreasView.vue?vue&type=template&id=2d1cb59e&scoped=true"
import script from "./AreasView.vue?vue&type=script&lang=js"
export * from "./AreasView.vue?vue&type=script&lang=js"

import "./AreasView.vue?vue&type=style&index=0&id=2d1cb59e&lang=less&scoped=true"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1cb59e"]])

export default __exports__